import faviconDev from 'url:../favicon-dev.svg';
import faviconUat from 'url:../favicon-uat.svg';

export type EnvironmentBannerConfig = {
  label: string;
  message: string;
  faviconPath: string;
  titleSuffix: string;
  bannerClassName: string;
};

const ENVIRONMENT_BANNERS: Partial<
  Record<string, EnvironmentBannerConfig>
> = {
  dev: {
    label: 'DEV',
    message:
      'DEV ENVIRONMENT – Test data only. Changes will not affect Production.',
    faviconPath: faviconDev,
    titleSuffix: ' [DEV]',
    bannerClassName: 'dev-environment-banner',
  },
  qa: {
    label: 'UAT',
    message:
      'UAT ENVIRONMENT – Test data only. Changes will not affect Production.',
    faviconPath: faviconUat,
    titleSuffix: ' [UAT]',
    bannerClassName: 'uat-environment-banner',
  },
};

/** Local parcel watch uses NODE_ENV=local; treat it like deployed dev for branding. */
const resolveEnvironmentKey = (env: string): string =>
  env === 'local' ? 'dev' : env;

/** True when the non-production environment banner should render (dev or UAT). */
export const showsEnvironmentBanner = (): boolean => {
  const env = process.env.NODE_ENV;
  if (!env) {
    return false;
  }

  const key = resolveEnvironmentKey(env);
  return key === 'dev' || key === 'qa';
};

/** @deprecated Use showsEnvironmentBanner — kept for existing imports. */
export const isUatEnvironment = (): boolean => process.env.NODE_ENV === 'qa';

export const getEnvironmentBannerConfig = ():
  | EnvironmentBannerConfig
  | undefined => {
  const env = process.env.NODE_ENV;
  if (!env) {
    return undefined;
  }

  return ENVIRONMENT_BANNERS[resolveEnvironmentKey(env)];
};

/** @deprecated Use getEnvironmentBannerConfig — kept for existing imports. */
export const getUatEnvironmentBannerConfig = getEnvironmentBannerConfig;

export type UatEnvironmentBannerConfig = EnvironmentBannerConfig;
